export const LABEL_LOGIN_LINK = 'login link - global header' as const;
export const LABEL_REGISTER_LINK = 'register link - global header' as const;
export const LABEL_PAGEVIEW_LIMIT = 'pageview limit reached' as const;
export const LABEL_SAVE_ITEM = 'save item - product page' as const;
export const LABEL_CONTACT_LINK = 'contact link in pdp' as const;
